import axios from 'axios';
import {
  EventCenterData,
  EventCenterFilters,
  NotificationEventsData,
  NotificationInstanceUsersData,
} from 'types/notification';
import { API_URL } from 'utils/http';

export function getGlobalNotifications({ page, search }) {
  return axios.get(`${API_URL}/notification/getGlobalNotifications`, {
    params: { page, search },
  });
}

export function getNotificationsInstanceUsers({ page, search, limit = 10 }) {
  return axios.get<NotificationInstanceUsersData>(
    `${API_URL}/notification/instanceusers`,
    {
      params: { page, search, limit },
    },
  );
}

export function addGlobalNotification(params: {
  event?: string;
  message?: string;
  usersIDs: string[];
  method: { email: boolean; alert: boolean };
  templateId?: string;
  templateParameters?: Record<string, string>;
  includeImpactedClusters?: boolean;
  searchConditions?: string;
  userInstanceData?: any; // Pre-filtered user-instance relationships
}) {
  return axios.post(`${API_URL}/notification/addGlobalNotification`, {
    params,
  });
}

export function getNotificationEvents() {
  return axios.get<NotificationEventsData>(`${API_URL}/notification/events`);
}

export function markNotificationEventsSeen(until: string) {
  return axios.post(`${API_URL}/notification/events/seen`, { until });
}

export function getEventCenter(filters: EventCenterFilters) {
  return axios.get<EventCenterData>(`${API_URL}/notification/event-center`, {
    params: filters,
  });
}
